import { defineMessages } from 'react-intl';

export default defineMessages({
  footerLinkFonts: {
    id: 'app.footer.links.fonts',
    defaultMessage: 'Fonts',
  },
  footerLinkTerms: {
    id: 'app.footer.links.terms',
    defaultMessage: 'Terms & conditions',
  },
  footerLinkPolicy: {
    id: 'app.footer.links.policy',
    defaultMessage: 'Privacy policy',
  },
  footerCompanyAddressLine1: {
    id: 'app.footer.address.line1',
    defaultMessage: '© MOO Print Limited, LABS Triangle, ',
  },
  footerCompanyAddressLine2: {
    id: 'app.footer.address.line2',
    defaultMessage: 'Chalk Farm Road, London, NW1 8AB. ',
  },
  footerCompanyAddressLine3: {
    id: 'app.footer.address.line3',
    defaultMessage: 'Registered in England, Company Number: 5121723',
  },
});
